import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import IngredientEditForm from '~/containers/ingredientEdit/ingredientEdit';
import IngredientArchive from '~/containers/ingredientArchive/ingredientArchive';

export class IngredientEditPage extends Component {
  state = {
    ingredient: null
  };

  onReceiveIngredient = ({ ingredient }) => {
    this.setState({
      ingredient
    });
  };

  render() {
    const ingredientId = this.props.match.params.ingredientId;
    const { ingredient } = this.state;

    const editButton = (
      <div className="flex">
        <IngredientArchive className="mr4" ingredient={ingredient} />
        <Link to={`/ingredients/${ingredientId}`}>
          <Button color="secondary">Cancel</Button>
        </Link>
      </div>
    );

    return (
      <Page>
        <TitleBar
          back={`/ingredients/${ingredientId}`}
          backText="Ingredient"
          title={ingredient ? ingredient.name : '...'}
          button={editButton}
        />
        <IngredientEditForm onCompleted={this.onReceiveIngredient} id={ingredientId} />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(IngredientEditPage));



// WEBPACK FOOTER //
// ./src/pages/ingredientEdit/ingredientEdit.jsx